import { ActiveACLs } from 'console/shared/device.acl/utils';
import { removeNulls } from 'utils';
export function getSharedAccountList(dev) {
    //Актуализируем доступ, может быть просрочен
    //Значит устройство в совместном доступе
    if (ActiveACLs(dev?.access ?? []).length == 0) {
        return null;
    }
    //Значит это наше устройство и мы его кому-то дали
    //Находим все имена, кому дали устройства
    return removeNulls((dev?.access ?? []).map((acl) => {
        if (acl.username) {
            return acl.username;
        }
        return null;
    }));
}
export function getSharedAccountListForCp(dev) {
    //Актуализируем доступ, может быть просрочен
    //Значит устройство в совместном доступе
    const list = dev?.access ?? [];
    if (ActiveACLs(list).length == 0) {
        return null;
    }
    return removeNulls(list.map(({ username, user_id }) => {
        if (username != null && user_id != null) {
            return {
                username,
                user_id,
            };
        }
        return null;
    }));
}
